module.exports = __webpack_public_path__ + "img/0Q3A7086_L_BlackMatted.3b0c80c0.jpg";